module.exports = __webpack_public_path__ + "img/rule-letter-magnifying-glass.001705c8.jpg";